// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(/* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var hasDoubleTicks = /* #__PURE__ */ Data_String_CodeUnits.contains("\"");
var hasCommas = /* #__PURE__ */ Data_String_CodeUnits.contains(",");
var printCell = function (v) {
    if (v instanceof Data_Maybe.Nothing) {
        return "";
    };
    if (v instanceof Data_Maybe.Just) {
        var $8 = not(hasDoubleTicks)(v.value0) && not(hasCommas)(v.value0);
        if ($8) {
            return v.value0;
        };
        return "\"" + (Data_String_Common.replaceAll("\"")("\"\"")(v.value0) + "\"");
    };
    throw new Error("Failed pattern match at Visonum.BulkPingApp.CSV (line 30, column 13 - line 36, column 78): " + [ v.constructor.name ]);
};
var printRow = function (cells) {
    return Data_String_Common.joinWith(",")(map(printCell)(cells));
};
var printCsv = function (v) {
    var head = printRow(map(Data_Maybe.Just.create)(v.headers)) + "\x0a";
    var body = Data_String_Common.joinWith("\x0a")(map(printRow)(v.rows));
    return head + body;
};
export {
    printCsv
};
//# sourceMappingURL=index.js.map
